var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalyst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.7443 4.61758 15.3824 0.255684 10 0.25ZM16.7378 5.24406L10.75 8.70063V1.78469C13.1562 2.00529 15.3448 3.2697 16.7378 5.24406ZM9.25 1.78469V9.56594L2.51031 13.4566C1.38758 11.0231 1.51686 8.19584 2.857 5.87497C4.19714 3.55409 6.58113 2.0288 9.25 1.78469ZM10 18.25C7.31984 18.2489 4.80724 16.9459 3.26219 14.7559L17.4897 6.5425C18.6687 9.09687 18.4648 12.076 16.9487 14.4459C15.4326 16.8158 12.8134 18.2497 10 18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalyst);
export default __webpack_public_path__ + "static/media/data-analyst.1b51a07c0a945bc04753711619fb3089.svg";
export { ForwardRef as ReactComponent };